/* eslint-disable class-methods-use-this */
import Component from '@bythepixel/component-loader';

export default class PartCard extends Component {
  static selector = '[data-comp-part-card]';

  constructor(containerEl) {
    super(containerEl);
    this.partDetails = this.getPartDetails();
    this.mount();
  }

  attachListeners() {
    this.$container.addEventListener('click', (e) => {
      const { target } = e;
      const isModalTrigger = this.isInModalTrigger(target);

      if (!isModalTrigger) {
        window.location = this.partDetails.partUrl;
      }
    });
  }

  /**
   * Recursive function to determine whether an element is, or is a descendant of, the
   * modal trigger button.
   *
   * @param { HTMLElement } element
   */
  isInModalTrigger(element) {
    const parentEl = element.parentElement;
    const trigger = element.dataset.compModalTrigger || parentEl?.dataset.compModalTrigger;
    const shouldStop = element.classList.contains('part-card');

    // if either element has the compModalTrigger property, we're either the button, or in it
    if (trigger) {
      return true;
    }

    // we've gone too far, we're definitely not in the trigger
    if (shouldStop || !parentEl) {
      return false;
    }

    // else we keep scanning
    return this.isInModalTrigger(parentEl);
  }

  getPartDetails() {
    const partDetails = {
      partUrl: '',
      partTitle: '',
      partPrice: '',
      partMsrp: '',
      partLocation: '',
      partLocationPhone: '',
    };

    Object.keys(partDetails).forEach((key) => {
      const value = this.$container.dataset[key];
      partDetails[key] = value;
    });

    return partDetails;
  }

  mount() {
    this.attachListeners();
  }
}
